import { useState, useEffect, useRef } from 'react';
import WaypointEditor from './sections/WaypointEditor.jsx';
import FeatureEditor from './sections/FeatureEditor.jsx';
import ChangeFeatureSection from './sections/ChangeFeatureSection.jsx';
import MassEditSection from './sections/MassEditSection.jsx';
import MirrorSection from './sections/MirrorSection.jsx';
import ExportSection from './sections/ExportSection.jsx';
import ToolsSection from './sections/ToolsSection.jsx';
import { useFile, useSelection } from '../context/AppContext.jsx';

export default function RightPanel() {
  const { currentFileData } = useFile();
  const { selectedWaypointIndex, selectedFeatureIndex } = useSelection();
  const panelRef = useRef(null);
  const [showSections, setShowSections] = useState({
    waypointEditor: false,
    featureEditor: false,
    changeFeature: false,
    massEdit: false,
    mirror: false,
    tools: false,
    export: false,
  });

  useEffect(() => {
    if (currentFileData) {
      setShowSections(prev => ({
        ...prev,
        changeFeature: true,
        massEdit: true,
        mirror: true,
        tools: true,
        export: true,
      }));
    }
  }, [currentFileData]);

  useEffect(() => {
    if (selectedWaypointIndex !== null) {
      setShowSections(prev => ({ ...prev, waypointEditor: true }));
      // Scroll to top of right panel
      if (panelRef.current) {
        panelRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }, [selectedWaypointIndex]);

  useEffect(() => {
    if (selectedFeatureIndex !== null) {
      setShowSections(prev => ({ ...prev, featureEditor: true }));
      // Scroll to top of right panel
      if (panelRef.current) {
        panelRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }, [selectedFeatureIndex]);

  return (
    <aside ref={panelRef} className="bg-bg-secondary rounded-xl p-6 overflow-y-auto w-80 flex flex-col gap-4">
      {!currentFileData && (
        <div className="text-center text-text-secondary p-8">
          <p>Select a waypoint or feature to edit, or use the tools below to transform multiple waypoints at once.</p>
        </div>
      )}

      {showSections.waypointEditor && selectedWaypointIndex !== null && <WaypointEditor />}
      {showSections.featureEditor && selectedFeatureIndex !== null && <FeatureEditor />}
      {showSections.changeFeature && currentFileData && <ChangeFeatureSection />}
      {showSections.massEdit && currentFileData && <MassEditSection />}
      {showSections.mirror && currentFileData && <MirrorSection />}
      {showSections.tools && currentFileData && <ToolsSection />}
      {showSections.export && currentFileData && <ExportSection />}
    </aside>
  );
}

